import { ReactElement, useId } from 'react';
import { Tooltip } from '@screentone/core';

export const READ_ONLY_TOOLTIP_MESSAGE = 'Unavailable while page is Read Only';

interface ReadOnlyTooltipProps {
  disabled: boolean;
  message?: string;
  children: ReactElement;
}

export const ReadOnlyTooltip = ({ disabled, message = READ_ONLY_TOOLTIP_MESSAGE, children }: ReadOnlyTooltipProps) => {
  // Several ReadOnlyTooltip instances can be disabled and rendered in the same open menu at once
  // (e.g. ClearItems and AddLinkedItem together), so the tooltip id must be unique per instance.
  const tooltipId = useId();

  if (!disabled) {
    return children;
  }

  return (
    <Tooltip data-testid="read-only-tooltip">
      <Tooltip.Content data-testid="read-only-tooltip-content" id={tooltipId} position="bottom" size="lg">
        {message}
      </Tooltip.Content>
      <Tooltip.Trigger data-testid="read-only-tooltip-trigger" aria-describedby={tooltipId}>
        {children}
      </Tooltip.Trigger>
    </Tooltip>
  );
};
